import { render } from "./UploadImage.vue?vue&type=template&id=ae57d204"
import script from "./UploadImage.vue?vue&type=script&lang=js"
export * from "./UploadImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__